import store from '@/store'
import storage from '@/libs/storage';
import wechat from '@/libs/wechat';
import { Base64 } from 'js-base64';
import { Dialog } from 'vant';
import CryptoJS from 'crypto-js';
export default {
    install(Vue) {
        Vue.prototype.cf = this
        this.$storage = Vue.prototype.$storage
    },

    isJSON(str) {
        if (typeof str === "string") {
            try {
                if (str.indexOf("{") > -1) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                return false;
            }
        } else if (typeof str === "object") {
            return true;
        }
        return false;
    },

    hc(s,n){
        let h=0,i=0,l=s.length?s.length:0;
        if(l>0)while(i<l)h=(h<<5)-h+s.charCodeAt(i++)|0;
        return Math.abs(h)%n
    },

    AesDecrypt(word) {
        if(word.length != 24) {
          return word;
        }
        const key = CryptoJS.enc.Latin1.parse("0102030405060708"); //十六位十六进制数作为秘钥
        const iv = CryptoJS.enc.Latin1.parse('0102030405060708');
        const decoded = CryptoJS.AES.decrypt(word, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          adding: CryptoJS.pad.ZeroPadding
         }).toString(CryptoJS.enc.Utf8)
        return decoded;
    },

    wxShareConf() {
        
        let link = `${window.location.protocol}//${window.location.host}${window.entryUrl}`
        storage.get("t").then((res) => {
        if (!!res) {
            res = res.replace(/^\s+|\s+$/gm, '');
            if (link.indexOf("?") === -1) {
            link = link + "?t=" + res
            } else {
            link = link + "&t=" + res
            }
        }
        storage.get('shareInfo').then((res) => {
            if (!!res) {
            return wechat.updateShareData(Object.assign(res, {
                link
            }))
            } else {
            return wechat.updateShareData({
                title: '线上运动会',
                link
            })
            }
        })
        })
    },

    isEmpty(val) {
        // null or undefined
        if (val == null) return true;
    
        if (typeof val === 'boolean') return false;
    
        if (typeof val === 'number') return !val;
    
        if (val instanceof Error) return val.message === '';
    
        switch (Object.prototype.toString.call(val)) {
          // String or Array
          case '[object String]':
          case '[object Array]':
            return !val.length;
    
          // Map or Set or File
          case '[object File]':
          case '[object Map]':
          case '[object Set]': {
            return !val.size;
          }
          // Plain Object
          case '[object Object]': {
            return !Object.keys(val).length;
          }
        }
    
        return false;
      },

    setLastRouter(to) {
        let {name, query, params} = to;
        let lastrouter = {name, query, params}
        this.$storage.set("lastroute", lastrouter);
    },
    async getLastRouter() {
        return this.$storage.get("lastroute").then((res) => {
            let lastroute = res
            if (!res) {
                lastroute = {name: "index"}
            }
            return lastroute
        });

    },

    isWeChat() {
        return (/micromessenger/i.test(window.navigator.userAgent))
    },

    async getToken() {
        let userInfo = await store.getters.getUserInfo
        if (userInfo && userInfo.token) return userInfo.token;
        return false;
    },
    countTime(createTime, fmt){
        var timestamp = new Date().getTime()/1000;
        var d, h, m, s,leftTime = timestamp-createTime;
        if (leftTime >= 0) {
            d = Math.floor(leftTime / 60 / 60 / 24);
            h = Math.floor(leftTime / 60 / 60 % 24);
            m = Math.floor(leftTime / 60 % 60);
            s = Math.floor(leftTime  % 60);
        }
        if (d) {
            return d + "天" + h + "小时" + m + "分";
        } else if(h) {
            // return d + "天" + h + "小时" + m + "分" + s + "秒";
            return h + "小时" + m + "分";

        } else if(m) {
            return m + "分";
        }else {
            return s + "秒";
        }

    },
    async loginConfirm(to) {
        //wechat
        //清空本地缓存
        store.commit('clearUserInfo');
        try {
            Dialog.confirm({
                title: '提示',
                message: '当前页面需要登录后才可访问,前往登录页面?',
            })
            .then(() => {
                wx.miniProgram.redirectTo({
                url: '/pages/user/userauth',
                });
            })
            .catch(() => {
                wx.miniProgram.reLaunch({
                url: '/pages/index/index',
                });
            });
        } catch (error) {
          let getCodeCount = window.localStorage.getItem("getCodeCount");
          if (this.isEmpty(getCodeCount)) getCodeCount = 0
          getCodeCount = +getCodeCount + 1
          //记录重试次数
          window.localStorage.setItem("getCodeCount", getCodeCount);
          if (+getCodeCount > 3) {
            Dialog.alert({
              message: '授权失败,请重新打开页面'
            }).then(() => {
              window.localStorage.removeItem("getCodeCount");
              // on close
            });
            return;
          }
          wechat.jsAuthorize()
        }
      }

}
